/* Montela Offer-Test A/B/C — cart attribute sync, local price fill-in and cart-drawer progress for offers A/B.
   Offer C (or no offer) = nothing changes: the Mix & Match progress stays off, as before. */
(function () {
  var O = window.MT_OFFER, C = window.MM || {};
  if (!O) return;
  /* 0) product-card badge (assets/mm.js labelCards reads MM.t.card): offer A = bundle price, offer B = 3rd pair −50 %, C = unchanged.
        ot.js is loaded before mm.js (both defer), so the swap happens before the cards are labelled. */
  if ((O.offer === 'a' || O.offer === 'b' || O.offer === 'c') && C.t && O.t && O.t['card_' + O.offer]) C.t.card = O.t['card_' + O.offer];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || C.currency || 'EUR';
  var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;

  function money(cents) {
    try {
      return new Intl.NumberFormat(C.locale || 'de-DE', { style: 'currency', currency: cur,
        currencyDisplay: cur === 'EUR' ? 'symbol' : 'code', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return Math.round(cents / 100) + ' ' + cur; }
  }
  /* Prices without a fixed local value: EUR amount × Shopify market rate, rounded to a whole unit (PROVISIONAL). */
  function fillPrices(scope) {
    (scope || document).querySelectorAll('[data-ot-eur]:not([data-ot-done])').forEach(function (el) {
      el.setAttribute('data-ot-done', '');
      var eur = parseInt(el.getAttribute('data-ot-eur'), 10);
      el.textContent = money(Math.round(eur * rate / 100) * 100);
    });
  }
  function tx(key) {
    var s = (O.t && O.t[key]) || '';
    var d = document.createElement('div');
    d.innerHTML = (O.t.a2 || '') + '|' + (O.t.a3 || '');
    fillPrices(d);
    var p = d.textContent.split('|');
    return s.replace('[x]', p[0] || '').replace('[y]', p[1] || '');
  }

  /* 1) cart attribute 'offer' (only when an offer was set, so C-without-cookie carts stay untouched) */
  /* Race-proof: the attribute is written immediately, every add-to-cart waits for that write, and it is re-asserted after
     every add/change (idempotent), so a cart can never reach checkout without 'offer'. */
  var _of = window.fetch, setOffer = function () {
    return _of.call(window, root + 'cart/update.js', { method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { offer: O.offer } }) }).catch(function () {});
  };
  var offerReady = Promise.resolve();
  if (O.offer && (O.offer === 'a' || O.offer === 'b' || O.offer === 'c')) {
    if (O.offer !== O.cartOffer) offerReady = setOffer();
    var _g = window.fetch;
    window.fetch = function (u0) {
      var u = String((u0 && u0.url) || u0 || ''), self = this, args = arguments;
      if (/\/cart\/(add|change)/.test(u)) {
        return offerReady.then(function () { return _g.apply(self, args); }).then(function (r) { offerReady = setOffer(); return r; });
      }
      return _g.apply(self, args);
    };
    document.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !/\/cart\/add/.test(f.action || '')) return;
      if (!f.querySelector('input[name="attributes[offer]"]')) { var i = document.createElement('input'); i.type = 'hidden'; i.name = 'attributes[offer]'; i.value = O.offer; f.appendChild(i); }
    }, true);
  }

  /* 2) cart-drawer progress (Kaching cart drawer) — offers A and B only */
  function isShoe(item) {
    if (!item || !item.price) return false;
    var type = (item.product_type || '').toLowerCase();
    if ((C.exTypes || []).indexOf(type) > -1) return false;
    var h = (item.handle || '').toLowerCase(), k = C.exKeys || [];
    for (var i = 0; i < k.length; i++) if (h.indexOf(k[i]) > -1) return false;
    return true;
  }
  function build(pairs) {
    if (pairs < 1) return '';
    var o = O.offer, n = pairs >= 3 ? 3 : pairs;
    var fill = n === 3 ? 100 : n === 2 ? 66 : 33;
    var p2 = (C.t && C.t.p2) || '2', p3 = (C.t && C.t.p3) || '3', p1 = (C.t && C.t.p1) || '1';
    return '<div class="ot-prog__msg">' + tx('pr_' + o + n) + '</div>' +
      '<div class="ot-prog__track"><div class="ot-prog__fill" style="width:' + fill + '%"></div></div>' +
      '<div class="ot-prog__steps"><span class="' + (n >= 1 ? 'on' : '') + '">' + p1 + '</span><span class="' +
      (n >= 2 ? 'on' : '') + '">' + p2 + '</span><span class="' + (n >= 3 ? 'on' : '') + '">' + p3 + '</span></div>';
  }
  var last = null, timer;
  function paint() {
    var drawer = document.querySelector('kaching-cart-drawer');
    if (!drawer || !last) return;
    var pairs = 0;
    (last.items || []).forEach(function (it) { if (isShoe(it)) pairs += it.quantity; });
    var html = build(pairs), box = drawer.querySelector('.ot-prog');
    if (!html) { if (box) box.remove(); return; }
    var header = drawer.querySelector('.kaching-cart__header');
    if (!box) {
      box = document.createElement('div'); box.className = 'ot-prog'; box.setAttribute('data-ot-show', O.offer);
      if (header) header.insertAdjacentElement('afterend', box); else drawer.insertBefore(box, drawer.firstChild);
    }
    if (box.innerHTML !== html) box.innerHTML = html;
  }
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (c) { last = c; paint(); }).catch(function () {});
    }, 250);
  }

  function init() {
    fillPrices();
    if (O.offer !== 'a' && O.offer !== 'b' && O.offer !== 'c') return;
    refresh();
    var _f = window.fetch;
    window.fetch = function () {
      var u = String((arguments[0] && arguments[0].url) || arguments[0] || '');
      var r = _f.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u)) r.then(refresh, refresh);
      return r;
    };
    new MutationObserver(function () { if (last) paint(); fillPrices(); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Offer A: per-pair picker (2026-10-24). '2 / 3 Paar wählen' opens one row per pair (colour + size; only available
   variants; size labels in local market sizes via window.mmSizeLabel from snippets/mm-au-sizes, values stay EU).
   One button adds all pairs at once: POST /cart/add.js {items:[{id,quantity}]} → Kaching Cart (which wraps window.fetch)
   picks up the add like the theme's own ATC and opens its drawer; fallback: kachingCartApi / cart-drawer / /cart. */
(function () {
  var COL = /^(farbe|colou?r|farve|färg|farge|couleur)$/i, SIZE = /^(größe|grösse|size|størrelse|storlek|taille|pointure)$/i;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sizeLabel(v) { try { return (window.mmSizeLabel && window.mmSizeLabel(v)) || v; } catch (e) { return v; } }
  function init(box) {
    var pk = box.querySelector('[data-ot-pk]'); if (!pk || pk._ot) return; pk._ot = 1;
    var D; try { D = JSON.parse(pk.querySelector('[data-ot-pk-data]').textContent); } catch (e) { return; }
    var opts = D.opts || [], V = D.v || [], T = D.t || {};
    var ci = -1, si = -1;
    opts.forEach(function (o, i) { if (COL.test(o)) ci = i; else if (SIZE.test(o)) si = i; });
    if (si < 0) si = opts.length - 1;
    if (ci === si) ci = -1;
    var rows = pk.querySelector('[data-ot-pk-rows]'), add = pk.querySelector('[data-ot-add]'), msg = pk.querySelector('[data-ot-pk-msg]');
    var n = 0, sel = [];
    function match(color, size) {
      for (var k = 0; k < V.length; k++) {
        var v = V[k];
        if (ci > -1 && v.o[ci] !== color) continue;
        if (si > -1 && size != null && v.o[si] !== size) continue;
        var ok = true; for (var x = 0; x < opts.length; x++) if (x !== ci && x !== si && v.o[x] !== V[0].o[x]) ok = false;
        if (ok && (size != null || v.a)) return v;
      }
      return null;
    }
    function colours() { var s = [], seen = {}; V.forEach(function (v) { var c = ci > -1 ? v.o[ci] : ''; if (!seen[c] && V.some(function (w) { return (ci < 0 || w.o[ci] === c) && w.a; })) { seen[c] = 1; s.push(c); } }); return s; }
    function sizes(c) { var s = []; V.forEach(function (v) { if ((ci < 0 || v.o[ci] === c) && v.a && s.indexOf(v.o[si]) < 0) s.push(v.o[si]); }); return s; }
    function current() {
      var f = document.querySelector('product-form form[action*="/cart/add"] input[name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = f && parseInt(f.value, 10);
      for (var k = 0; k < V.length; k++) if (V[k].id === id) return V[k];
      return null;
    }
    function render() {
      var cs = colours(), h = '';
      for (var i = 0; i < n; i++) {
        var s = sel[i], v = s.size != null ? match(s.color, s.size) : null;
        var img = (v && v.img) || (match(s.color, null) || V[0]).img;
        h += '<div class="ot-pk__row" data-i="' + i + '"><div class="ot-pk__hd"><span class="ot-pk__n">' + esc(T.pair) + ' ' + (i + 1) + '</span>' +
          (v && v.a ? '<span class="ot-pk__stock">' + esc(T.stock) + '</span>' : '') +
          (n >= 2 ? '<button type="button" class="ot-pk__x" data-ot-rm aria-label="' + esc(T.rm + ' ' + (i + 1)) + '">&times;</button>' : '') +
          '</div><div class="ot-pk__body"><img class="ot-pk__img" src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy"><div class="ot-pk__sel">';
        if (ci > -1) {
          h += '<label class="ot-pk__lab"><span class="ot-pk__l">' + esc(T.color) + '</span><select data-k="color">';
          cs.forEach(function (c) { h += '<option value="' + esc(c) + '"' + (c === s.color ? ' selected' : '') + '>' + esc(c) + '</option>'; });
          h += '</select></label>';
        }
        h += '<label class="ot-pk__lab"><span class="ot-pk__l">' + esc(T.size) + '</span><select data-k="size"><option value="">' + esc(T.choose) + '</option>';
        sizes(s.color).forEach(function (z) { h += '<option value="' + esc(z) + '"' + (z === s.size ? ' selected' : '') + '>' + esc(sizeLabel(z)) + '</option>'; });
        h += '</select></label></div></div></div>';
      }
      rows.innerHTML = h;
      add.querySelector('[data-ot-add-txt]').textContent = String(T.add || '').replace('[n]', n).replace('[p]', n === 3 ? T.p3 : T.p2);
      if (more) more.hidden = n >= 3;
      box.querySelectorAll('[data-ot-pick]').forEach(function (x) { x.setAttribute('aria-pressed', +x.getAttribute('data-ot-pick') === n ? 'true' : 'false'); });
      box.querySelectorAll('.ot-a__card, .ot-m__card').forEach(function (c) { c.classList.toggle('is-on', +c.getAttribute('data-ot-qty') === n); });
      msg.textContent = '';
    }
    var more = pk.querySelector('[data-ot-more]');
    if (more) more.addEventListener('click', function (e) { e.preventDefault(); if (n >= 3) return; sel.push({ color: sel[n - 1].color, size: sel[n - 1].size }); n++; render(); });
    rows.addEventListener('click', function (e) {
      var x = e.target.closest('[data-ot-rm]'); if (!x) return;
      e.preventDefault();
      if (n <= 2) {
        /* back to 1 pair = normal PDP: close the panel, deselect both cards; the theme's own picker + ATC are untouched */
        n = 0; sel = []; pk.hidden = true; rows.innerHTML = ''; msg.textContent = '';
        box.querySelectorAll('[data-ot-pick]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        box.querySelectorAll('.ot-a__card, .ot-m__card').forEach(function (c) { c.classList.remove('is-on'); });
        return;
      }
      sel.splice(+x.closest('.ot-pk__row').getAttribute('data-i'), 1); n--; render();
    });
    rows.addEventListener('change', function (e) {
      var r = e.target.closest('.ot-pk__row'); if (!r) return;
      var i = +r.getAttribute('data-i'), k = e.target.getAttribute('data-k');
      if (k === 'color') { sel[i].color = e.target.value; if (sizes(sel[i].color).indexOf(sel[i].size) < 0) sel[i].size = null; }
      else sel[i].size = e.target.value || null;
      render();
    });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ot-pick]'); if (!b) { var cd = e.target.closest('.ot-a__card'); b = cd && cd.querySelector('[data-ot-pick]'); } if (!b) return;
      e.preventDefault();
      n = parseInt(b.getAttribute('data-ot-pick'), 10) || 2;
      var cur = current(), cs = colours();
      var c0 = cur && ci > -1 ? cur.o[ci] : cs[0], s0 = cur && cur.a ? cur.o[si] : null;
      if (cs.indexOf(c0) < 0) c0 = cs[0];
      while (sel.length < n) sel.push({ color: sel.length ? sel[sel.length - 1].color : c0, size: sel.length ? sel[sel.length - 1].size : s0 });
      sel.length = n;
      render();
      pk.hidden = false;
      var top = pk.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
      var hdr = document.querySelector('sticky-header'), hh = hdr ? Math.min(hdr.getBoundingClientRect().height, 200) : 0;
      window.scrollTo({ top: Math.max(0, top - hh - 16), behavior: 'smooth' });
    });
    add.addEventListener('click', function (e) {
      e.preventDefault();
      var items = [], q = {};
      for (var i = 0; i < n; i++) {
        var v = sel[i].size != null ? match(sel[i].color, sel[i].size) : null;
        if (!v || !v.a) { msg.textContent = T.err; var bad = rows.querySelector('.ot-pk__row[data-i="' + i + '"] select[data-k="size"]'); if (bad) bad.focus(); return; }
        q[v.id] = (q[v.id] || 0) + 1;
      }
      Object.keys(q).forEach(function (id) { items.push({ id: +id, quantity: q[id] }); });
      add.disabled = true; msg.textContent = T.busy;
      fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          msg.textContent = '';
          setTimeout(function () {
            var open = document.querySelector('.kaching-cart.active');
            if (open) return;
            try { if (window.kachingCartApi && typeof kachingCartApi.openCart === 'function') return kachingCartApi.openCart(); } catch (x) {}
            var d = document.querySelector('cart-drawer'); if (d && typeof d.open === 'function') return d.open();
            location.href = root + 'cart';
          }, 900);
        })
        .catch(function (err) { msg.textContent = (err && err.description) || T.fail; })
        .then(function () { add.disabled = false; });
    });
  }
  function boot() { document.querySelectorAll('.ot-box--a, .ot-box--b, .ot-box--c').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
/* Upsell note in the Kaching drawer: the Kaching custom JS writes a Mix & Match note (.mt-up-note, "Noch 1 Paar → –25 % auf alles").
   For offers A/B that note is hidden by CSS (ot-head) and replaced by our own .ot-up-note with the offer's terms. Kaching itself is untouched. */
(function () {
  var O = window.MT_OFFER; if (!O || (O.offer !== 'a' && O.offer !== 'b')) return;
  var L = (O.lang || 'de'); var strip = function (h) { var d = document.createElement('div'); d.innerHTML = h || ''; return d.textContent.trim(); };
  var a2 = strip(O.t && O.t.a2), a3 = strip(O.t && O.t.a3);
  var T = {
    de: { a: ['Mit 2 Paar: 2 Paar ' + a2, 'Noch 1 Paar → 2 Paar ' + a2, 'Noch 1 Paar → 3 Paar ' + a3, 'Winter-Bundle aktiv ✓'], b: ['Mit 2 Paar: −15 %', 'Noch 1 Paar → −15 %', 'Noch 1 Paar → 3. Paar −50 %', 'Alle Vorteile aktiv ✓'] },
    en: { a: ['With 2 pairs: 2 pairs ' + a2, '1 more pair → 2 pairs ' + a2, '1 more pair → 3 pairs ' + a3, 'Winter bundle active ✓'], b: ['With 2 pairs: −15%', '1 more pair → −15%', '1 more pair → 3rd pair −50%', 'All benefits active ✓'] },
    da: { a: ['Med 2 par: 2 par ' + a2, '1 par mere → 2 par ' + a2, '1 par mere → 3 par ' + a3, 'Vinterbundt aktiv ✓'], b: ['Med 2 par: −15 %', '1 par mere → −15 %', '1 par mere → 3. par −50 %', 'Alle fordele aktive ✓'] },
    sv: { a: ['Med 2 par: 2 par ' + a2, '1 par till → 2 par ' + a2, '1 par till → 3 par ' + a3, 'Vinterpaket aktivt ✓'], b: ['Med 2 par: −15 %', '1 par till → −15 %', '1 par till → 3:e paret −50 %', 'Alla förmåner aktiva ✓'] },
    nb: { a: ['Med 2 par: 2 par ' + a2, '1 par til → 2 par ' + a2, '1 par til → 3 par ' + a3, 'Vinterpakke aktiv ✓'], b: ['Med 2 par: −15 %', '1 par til → −15 %', '1 par til → 3. par −50 %', 'Alle fordeler aktive ✓'] },
    fr: { a: ['Avec 2 paires : 2 paires ' + a2, 'Encore 1 paire → 2 paires ' + a2, 'Encore 1 paire → 3 paires ' + a3, 'Pack hiver activé ✓'], b: ['Avec 2 paires : −15 %', 'Encore 1 paire → −15 %', 'Encore 1 paire → 3e paire −50 %', 'Tous les avantages activés ✓'] }
  };
  var tx = (T[L] || T.de)[O.offer];
  var EX = /magiesohlen|ratgeber|guide|fersen|heel|socke|strumpf|bandage|waschbeutel|sock|insole|sohle/i;
  var pairs = null, lineTot = 0, busy = false, sig = null, VP = {}, cartCur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', A2 = parseInt(O.t && O.t.a2c, 10) || 0, A3 = parseInt(O.t && O.t.a3c, 10) || 0, root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function load() { if (busy) return; busy = true; fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (c) { var p = 0, l = 0; (c.items || []).forEach(function (i) { if (i.final_price > 0 && !EX.test(i.handle || '') && !EX.test(i.product_type || '')) { p += i.quantity; l += i.original_line_price || i.line_price || 0; } }); lineTot = l; cartCur = c.currency || cartCur; pairs = p; busy = false; paint(); }).catch(function () { busy = false; }); }

  /* Suggestion-card prices (Kaching computes them with Mix & Match terms): rewritten per offer.
     A: incremental price to the next bundle (fixed bundle prices per currency from snippets/ot-price = SupaEasy);
     B: 2nd pair −15 %, 3rd pair −50 %. Variant prices come from /products/<handle>.js (market currency). */
  var TPL = null; /* Kaching's own money text (e.g. "€46,71" / "381,65 DKK") is used as the format template */
  function fmt(c) {
    var whole = c % 100 === 0, v = c / 100;
    if (TPL) {
      var m = TPL.match(/\d[\d.,\u00a0\u202f ]*\d|\d/); if (m) {
        var num = m[0], dec = /[.,]\d{2}$/.test(num) ? num.charAt(num.length - 3) : (cartCur === 'EUR' || cartCur === 'DKK' || cartCur === 'NOK' || cartCur === 'SEK' ? ',' : '.');
        var th = dec === ',' ? '.' : ',', ip = Math.floor(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, th);
        var s = ip + (whole ? '' : dec + Math.round((v - Math.floor(v)) * 100).toString().padStart(2, '0'));
        return TPL.replace(num, s);
      }
    }
    try { return new Intl.NumberFormat((window.MM && MM.locale) || 'de-DE', { style: 'currency', currency: cartCur,
      currencyDisplay: cartCur === 'EUR' ? 'symbol' : 'code', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(v); }
    catch (e) { return v.toFixed(whole ? 0 : 2) + ' ' + cartCur; }
  }
  function vprice(h, vid) {
    var k = h; if (VP[k] === undefined) { VP[k] = null;
      fetch(root + 'products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (p) { var m = {}; (p.variants || []).forEach(function (v) { m[v.id] = v.price; }); m._ = p.price; VP[k] = m; paint(); }).catch(function () {}); }
    var m = VP[k]; if (!m) return null; return m[vid] != null ? m[vid] : m._;
  }
  function priceText(base) {
    var n = pairs;
    if (O.offer === 'a') {
      if (n === 1 && A2) return '+' + fmt(Math.max(A2 - lineTot, 0));
      if (n === 2 && A3 && A2) return '+' + fmt(A3 - A2);
      if (n === 0 && A2) return fmt(base);
      return fmt(base);
    }
    /* same rounding as Shopify discounts: discount amount rounded half-up, price = base − discount */
    if (n === 1) return fmt(base - Math.round(base * 0.15));
    if (n === 2) return fmt(base - Math.round(base * 0.5));
    return fmt(base);
  }
  function prices() {
    document.querySelectorAll('.kaching-product-upsell-item').forEach(function (it) {
      var f = it.querySelector('.kaching-product-upsell-item__price-final'); if (!f) return;
      if (/\d/.test(f.textContent)) TPL = f.textContent.trim();
      var base = vprice(it.getAttribute('data-product-handle'), it.getAttribute('data-variant-id')); if (base == null) return;
      var t = priceText(base);
      var o = it.querySelector('.ot-up-price');
      if (!o || o.previousElementSibling !== f) { if (o) o.remove(); o = document.createElement('span'); o.className = 'ot-up-price kaching-product-upsell-item__price-final-ot'; f.insertAdjacentElement('afterend', o); }
      if (o.textContent !== t) o.textContent = t;
      if (it.getAttribute('data-ot-p') !== t) it.setAttribute('data-ot-p', t);
    });
  }
  function paint() {
    var s2 = Array.prototype.map.call(document.querySelectorAll('#kaching-cart .kaching-cart-item'), function (e) { return e.textContent.length + ':' + (e.querySelector('input') || {}).value; }).join('|');
    if (s2 !== sig) { sig = s2; load(); }
    if (pairs == null) return;
    var t = tx[Math.min(pairs, 3)];
    document.querySelectorAll('.kaching-upsell-module--product-upsell .kaching-product-upsell-item').forEach(function (it) {
      var pc = it.querySelector('.kaching-product-upsell-item__price-container'); if (!pc) return;
      var n = it.querySelector('.ot-up-note');
      if (!n) { n = document.createElement('div'); n.className = 'ot-up-note'; var mt = it.querySelector('.mt-up-note'); pc.parentNode.insertBefore(n, (mt || pc).nextSibling); }
      if (n.textContent !== t) n.textContent = t;
    });
    prices();
  }
  var q = false; new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; paint(); }); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
